import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { LocationRefService } from '../../share/services/location-ref.service';
import { Pages, toCommands } from '../../../constants/pages';

export const defaultRouting: CanActivateChildFn = ({ queryParams }: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const location = inject(LocationRefService);
  const pathName = location.nativeLocation.pathname;

  if (pathName.indexOf('/join') !== -1) {
    router.navigate(toCommands(Pages.join), { queryParams });
    return false;
  }

  if (pathName.indexOf('/account') !== -1) {
    router.navigate(toCommands(Pages.account), { queryParams });
    return false;
  }

  if (pathName.indexOf('/renew') !== -1) {
    router.navigate(toCommands(Pages.renew), { queryParams });
    return false;
  }

  if (pathName.indexOf('/gift') !== -1) {
    router.navigate(toCommands(Pages.giftOffers), { queryParams });
    return false;
  }

  return true;
};

export default defaultRouting;
